<template>
  <div class="select-course-assistant">
    <div class="select-course-assistant-header">
      <header-back-btn v-if="!isAppWebView" />
    </div>
    <start-page v-if="showStartPage"
                @show-grade-list="handleShowGradeList"
    />
    <grade-list-page v-if="showGradeListPage"
                     :list="gradeList"
                     :vip="vip"
                     @show-category="handleShowCategory"
    />
    <category-page v-if="showCategoryPage"
                   :list="category"
                   @show-question-list="handleShowQuestionList"
                   @show-qr-code="handleShowQrCode"
    />
    <question-list-page v-if="showQuestionListPage"
                        :list="questionList"
    />
    <qr-code-popup :show.sync="showQrCode"
                   :src="require('@/assets/img/select_course_assistant/qr_code.jpeg')"
                   title="添加老师咨询"
                   hint="扫码添加课程老师，咨询课程详情"
    >
      <div class="select-course-assistant-qr-code-btn"
           @click="handleClickQrCodeBtn"
      >
        查看更多课程
      </div>
    </qr-code-popup>
  </div>
</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import QrCodePopup from '@/components/QrCodePopup';
  import StartPage from '@/pages/SelectCourseAssistant/components/StartPage';
  import GradeListPage from '@/pages/SelectCourseAssistant/components/GradeListPage';
  import CategoryPage from '@/pages/SelectCourseAssistant/components/CategoryPage';
  import QuestionListPage from '@/pages/SelectCourseAssistant/components/QuestionListPage';
  import { locationHref, isAppWebView } from '@/utils';
  import { getStaticShareInfo } from '@/services/app';

  export default {
    name: 'SelectCourseAssistant',
    metaInfo: {},
    components: {
      HeaderBackBtn,
      QrCodePopup,
      StartPage,
      GradeListPage,
      CategoryPage,
      QuestionListPage,
    },
    data() {
      return {
        gradeList: [
          {
            id: 1,
            name: '2年级及以下',
          },
          {
            id: 2,
            name: '3-6年级',
          },
          {
            id: 3,
            name: '7年级以上',
          },
        ],
        vip: [
          {
            id: 1,
            path: 'https://m.youthmba.com/vip/1',
            question: '',
            answer: '年卡会员可畅听百门精品音频课，低年级同学适合经典故事音频，如《哈利·波特》、《查理与巧克力工厂》、《奇幻镜花缘》等，从故事中学习人生哲理，潜移默化培养阅读习惯。更有学习方法、亲子教养类课程，帮助孩子打好基础。',
          },
          {
            id: 1,
            path: 'https://m.youthmba.com/vip/1',
            question: '',
            answer: '年卡会员可畅听百门精品音频课，包含全球顶级科学博士的科普课，世界经典文学及人物传记课，以及改善拖延症、激发内驱力的学习方法课，帮助孩子扩充知识面，全面提升学习能力。',
          },
        ],
        category: [
          {
            name: '演讲表达',
            list: [
              {
                id: 204,
                path: 'https://m.youthmba.com/audio/204',
                question: '表达欲旺盛、喜欢说话，但噼里啪啦没重点、没逻辑',
                answer: '该课程会提供多种经典演讲结构如：三点法、黄金表达公式以及金字塔结构等。帮助孩子掌握结构化表达的能力，做到逻辑清晰、表达精准、不废话。',
              },
              {
                id: 113,
                path: 'https://m.youthmba.com/audio/113',
                question: '即将面临升学面试，口头表达能力需要提升',
                answer: '该课程除了教授专业的表达知识外，还融合多种生活学习实际场景如：升学/留学面试、班委竞选、学校汇报等进行实战训练。让自信表达成为孩子成长中的优势，给他人留下深刻的印象。',
              },
              {
                id: 53,
                path: 'https://m.youthmba.com/audio/53',
                question: '平时看书少，一面临写作或演讲就犯难，缺少素材，不会总结自己的观点',
                answer: '该课程将教会孩子如何对演讲素材分类整理、贴标签，对素材进行活用，让自己的演讲表达有内容、富有情感并且有说服力。同时，这也是提升写作输出的有效方法之一，达到演讲写作双提升。',
              },
              {
                id: 113,
                path: 'https://m.youthmba.com/audio/113',
                question: '有演讲基础，想系统提升演讲能力，但找不到好的课程或老师',
                answer: '少年商学院备受好评的明星课程，从基础的讲故事，到如何有效表达观点，再到面试、辩论等实战应用场景，系统培养演讲表达能力，让孩子敢讲，会讲，讲得好。',
              },
              {
                id: 53,
                path: 'https://m.youthmba.com/audio/53',
                question: '害怕课堂上被点名发言，当众不敢开口说话',
                answer: '从常见的表达场景入手，通过组织最简单的故事素材、发表自己的观点到有效演绎，让学生告别回答问题时缺少说服力、毫无章法的困扰，摆脱不知道讲什么好的尴尬，减缓恐惧与紧张。',
              },
            ],
          },
          {
            name: '财商思维',
            list: [
              {
                id: 8,
                path: 'https://m.youthmba.com/audio/8',
                question: '花钱没概念、看到想要的东西就冲动消费',
                answer: '透过拆解常见的商业社会现象，让孩子掌握基本的商业知识及经济学原理，学会合理做决策，懂得聪明花钱，养成用钱好习惯。',
              },
              {
                id: 5,
                path: 'https://m.youthmba.com/audio/5',
                question: '爱和同学攀比，别人有的他也要有',
                answer: '课程采用多元化案例，既有全球知名案例也有生活情景教学、结合热点话题分析，引导孩子建立正确、科学的金钱观，成为讲诚信、懂感恩的人。',
              },
              {
                id: 182,
                path: 'https://m.youthmba.com/audio/182',
                question: '缺乏理财意识，不懂合理管理零用钱',
                answer: '课程将多角度解析“财富、消费、投资、职业、社会责任”五大小学生必备的理财观念，搭配理财工具系统性提升理财能力与规划意识。',
              },
            ],
          },
          {
            name: '商业创新',
            list: [
              {
                id: 521,
                path: 'https://m.youthmba.com/course/521',
                question: '喜欢夸夸其谈，从不主动思考，也不动手实践',
                answer: '独立自主意识与规划能力 像顶级CEO一样思考、决策并行动',
              },
              {
                id: 521,
                path: 'https://m.youthmba.com/course/521',
                question: '经常有很多“鬼点子”，但都是天马行空，不加思考',
                answer: '系统认识一般商业实践过程，从中学习规律并分析，指导决策和实践',
              },
            ],
          },
          {
            name: '财经素养',
            list: [
              {
                id: 8,
                path: 'https://m.youthmba.com/audio/8',
                question: '只盯着“钱”本身，无法更宏观的角度看问题',
                answer: '简单又有趣的经济学案例，生动讲解经济学基础概念，激发孩子的经济学思维与兴趣',
              },
              {
                id: 8,
                path: 'https://m.youthmba.com/audio/8',
                question: '接触社会现象，但无法用客观、独立的视觉看到本质',
                answer: '通过观察身边的现象学习经济规律。获得探索世界的全新思维与视觉',
              },
            ],
          },
          {
            name: '其他',
            list: [],
          },
        ],

        showStartPage: true,
        showGradeListPage: false,
        showCategoryPage: false,
        showQuestionListPage: false,

        showQrCode: false,
        questionList: [],
        isAppWebView: isAppWebView(),
      };
    },
    methods: {
      async getStaticShareInfo() {
        await getStaticShareInfo({
          type: 'selectCourseAssistant',
        });
      },
      handleShowGradeList() {
        this.showStartPage = false;
        this.showGradeListPage = true;
      },
      handleShowCategory() {
        this.showGradeListPage = false;
        this.showCategoryPage = true;
      },
      handleShowQuestionList(list) {
        this.questionList = list;
        this.showCategoryPage = false;
        this.showQuestionListPage = true;
      },
      handleShowQrCode() {
        this.showQrCode = true;
      },
      handleClickQrCodeBtn() {
        locationHref('https://m.youthmba.com/');
      },
    },
    created() {
      this.getStaticShareInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-course-assistant {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: 148px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #13b9bf;

    &-header {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      margin-bottom: @size-large;
      padding-left: @size-base;
      display: flex;
      align-items: center;
    }

    &-qr-code-btn {
      width: 450px;
      height: 100px;
      margin-top: @size-large;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-primary;
      font-size: @font-size-medium;
      border-radius: 50px;
      border: 1px solid @color-primary;
    }
  }

</style>
